import React from 'react'

function Button({bill, person,display, amount,tip, setcheck,check}) {

    const handleClick=(e)=>{
        e.preventDefault();
        if(person=== 0){
          setcheck(!check);
          console.log(check);
        }
        else{
           let per= e.target.value;
        //calculalte tipe per peson
        let tipAmount=parseFloat((per/100) * bill).toFixed(2)
        tip(tipAmount);
        //calculate total amont
        let total= parseFloat(tipAmount* person).toFixed(2);
        amount(total);
        }       
    }

  return (
    <>
     <button onClick={handleClick} className='p-2 hover:bg-primary-200 hover:text-primary-900 bg-primary-900  flex-auto rounded m-1' value={display}>{display}%</button>
    </>
  )
}

export default Button